import { render, staticRenderFns } from "./PlaceOrderButton.vue?vue&type=template&id=c843fb20&"
import script from "./PlaceOrderButton.vue?vue&type=script&lang=js&"
export * from "./PlaceOrderButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports